import React, { useEffect, useState } from 'react';
import {
    Box,
    Toolbar,
    Typography,
    Paper,
    Stack,
    Chip,
    Divider,
    CircularProgress,
    TextField,
    Button,
} from '@mui/material';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API } from '../../../utils/Api';
import { KeyboardArrowLeft } from '@mui/icons-material';

const StockRequestDetails = () => {
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const token = localStorage.getItem('token');

    const [indent, setIndent] = useState(location.state?.indent || null);
    const [loading, setLoading] = useState(!location.state?.indent);
    const [receivedMap, setReceivedMap] = useState({});

    const formatDate = (value) => {
        if (!value) return '-';
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return '-';
        return d.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });
    };

    const statusColor = (status = '') => {
        const s = status.toLowerCase();
        if (s === 'approved') return 'success';
        if (s === 'rejected') return 'error';
        if (s === 'completed') return 'success';
        return 'warning';
    };

    const buildInitialReceived = (indentData) => {
        const map = {};
        (indentData.items || []).forEach((it) => {
            map[it._id] = it.recievedQuantity > 0 ? it.recievedQuantity : '';
        });
        return map;
    };

    const handleReceivedChange = (itemId, value) => {
        if (value !== '' && isNaN(Number(value))) return;
        setReceivedMap((prev) => ({
            ...prev,
            [itemId]: value,
        }));
    };

    const handleBack = () => {
        navigate(-1);
    };

    // const setAsCompleted = async () => {
    //     console.log('running');
    //     const shouldMarkCompleted =
    //         areAllItemsReceived(indent, receivedMap) &&
    //         (indent.status || '').toUpperCase() !== 'COMPLETED';
    //     const itemsPayload = (indent.items || []).map((it) => ({
    //         itemId: it._id,
    //         status: (it.status || 'PENDING').toUpperCase(),
    //     }));
    //     if (shouldMarkCompleted) {
    //         console.log('running 2');
    //         try {
    //             await axios.put(
    //                 `${API.BASE_URL}material-request-indent`,
    //                 {
    //                     _id: indent._id,
    //                     status: 'COMPLETED',
    //                     items: itemsPayload
    //                 },
    //                 {
    //                     headers: { Authorization: `Bearer ${token}` },
    //                 }
    //             );
    //             setIndent((prev) =>
    //                 prev ? { ...prev, status: 'COMPLETED' } : prev
    //             );
    //             toast.success('Indent marked as COMPLETED.');
    //         } catch (statusError) {
    //             console.error(statusError);
    //             toast.error(
    //                 'Received quantities saved, but failed to mark indent as COMPLETED.'
    //             );
    //         }
    //     }
    // };

    const areAllItemsReceived = (indentArg) => {
        if (!indentArg?.items?.length) return false;

        return indentArg.items
            // Ignore rejected items
            .filter((it) => (it.status || 'PENDING').toUpperCase() !== 'REJECTED')
            .every((it) => {
                const requested = Number(it.requestedQuantity || 0);
                const received = Number(it.recievedQuantity || 0);

                // If no requested qty, treat as auto-satisfied
                if (!requested) return true;

                return received >= requested;
            });
    };

    const markIndentCompletedIfNeeded = async (indentArg, token, setIndent) => {
        if (!indentArg) return;
        console.log('3rd');

        const shouldMarkCompleted =
            areAllItemsReceived(indentArg) &&
            (indentArg.status || '').toUpperCase() !== 'COMPLETED';

        if (!shouldMarkCompleted) return;
        console.log('4th');

        const itemsPayload = (indentArg.items || []).map((it) => ({
            itemId: it._id,
            status: (it.status || 'PENDING').toUpperCase(),
        }));

        try {
            await axios.put(
                `${API.BASE_URL}material-request-indent`,
                {
                    _id: indentArg._id,
                    status: 'COMPLETED',
                    items: itemsPayload,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            setIndent((prev) =>
                prev ? { ...prev, status: 'COMPLETED' } : prev
            );

            toast.success('Indent marked as COMPLETED.');
        } catch (statusError) {
            console.error(statusError);
            toast.error(
                'Received quantities saved, but failed to mark indent as COMPLETED.'
            );
        }
    };

    useEffect(() => {
        console.log('1st');
        if (!indent) return;
        console.log('2nd');
        setReceivedMap(buildInitialReceived(indent));
        markIndentCompletedIfNeeded(indent, token, setIndent);
    }, [indent]);

    const handleSaveReceived = async () => {
        try {
            const payloads = (indent.items || [])
                .filter((it) => {
                    const itemStatus = (it.status || 'PENDING').toUpperCase();
                    const isRejected = itemStatus === 'REJECTED';
                    if (isRejected) return false;
                    // const value = receivedMap[it._id];
                    // return value !== undefined && value !== '';
                    const rawValue = receivedMap[it._id];
                    if (rawValue === undefined || rawValue === '') return false;
                    const newReceived = Number(rawValue);
                    if (Number.isNaN(newReceived)) return false;
                    const existingReceived = Number(it.recievedQuantity || 0);
                    return newReceived !== existingReceived;
                })
                .map((it) => {
                    const value = receivedMap[it._id];

                    return {
                        _id: indent._id,
                        rawMaterialId: it.rawMaterial?._id || null,
                        remark: '',
                        recievedQuantity: Number(value),
                    };
                });
            if (!payloads.length) {
                toast.info('No changes to save.');
                return;
            }

            await Promise.all(
                payloads.map((body) =>
                    axios.put(
                        `${API.BASE_URL}material-request-indent/update-remark`,
                        body,
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    )
                )
            );

            const updatedIndent = {
                ...indent,
                items: (indent.items || []).map((it) => {
                    const newVal = receivedMap[it._id];
                    if (newVal === undefined || newVal === '') return it;
                    return {
                        ...it,
                        recievedQuantity: Number(newVal),
                    };
                }),
            };
            setIndent(updatedIndent);
            toast.success('Received quantities updated successfully.');

            await markIndentCompletedIfNeeded(updatedIndent, token, setIndent);
        } catch (error) {
            console.error(error);
            toast.error(
                error?.response?.data?.error ||
                'Failed to update received quantities.'
            );
        }
    };

    if (loading || !indent) {
        return (
            <Box
                sx={{
                    background: 'linear-gradient(135deg, #f3f4f7 0%, #eef2f7 100%)',
                    minHeight: '100vh',
                }}
            >
                <Toolbar />
                <Box
                    sx={{
                        maxWidth: 900,
                        mx: 'auto',
                        px: 3,
                        pb: 4,
                    }}
                >
                    <Box
                        sx={{
                            height: '60vh',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'text.secondary',
                        }}
                    >
                        <CircularProgress size={30} />
                        <Typography variant="body1" sx={{ mt: 1.8, fontSize: 14 }}>
                            Loading indent details...
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    }

    const items = indent.items || [];
    const outlet = indent.outlet || {};
    const upperStatus = (indent.status || 'PENDING').toUpperCase();

    return (
        <Box
            sx={{
                background: 'linear-gradient(135deg, #f3f4f7 0%, #eef2f7 100%)',
                minHeight: '100vh',
            }}
        >
            <Toolbar />
            <Box
                sx={{
                    maxWidth: 900,
                    mx: 'auto',
                    px: 3,
                    pb: 4,
                }}
            >
                <Box
                    sx={{
                        mt: 3,
                        pt: 5,
                        mb: 2.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 2,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.8 }}>
                        <Box
                            sx={(theme) => ({
                                width: 48,
                                height: 48,
                                borderRadius: 2,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: theme.palette.primary.light + '22',
                                color: theme.palette.primary.main,
                            })}
                        >
                            <Inventory2OutlinedIcon fontSize="medium" />
                        </Box>
                        <Box>
                            <Typography
                                variant="h5"
                                fontWeight={700}
                                sx={{ color: '#003049', fontSize: 22 }}
                            >
                                Indent Details
                            </Typography>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ fontSize: 13, mt: 0.3 }}
                            >
                                {indent.indentNumber} • Fin. Year: {indent.fin_year || '-'}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ fontSize: 12.5, mt: 0.3 }}
                            >
                                Created on: {formatDate(indent.createdAt)}
                            </Typography>
                            {outlet?.name && (
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ fontSize: 12.5, mt: 0.3 }}
                                >
                                    Outlet: {outlet.name}
                                    {outlet.city ? ` • ${outlet.city}` : ''}
                                </Typography>
                            )}
                        </Box>
                    </Box>

                    <Stack spacing={1} alignItems="flex-end">
                        <Chip
                            size="small"
                            label={upperStatus}
                            color={statusColor(upperStatus)}
                            sx={{
                                fontSize: 11.5,
                                height: 24,
                                textTransform: 'uppercase',
                                fontWeight: 600,
                            }}
                        />
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={handleBack}
                            sx={{ textTransform: 'none', fontSize: 12 }}
                        >
                            Back to list
                        </Button>
                    </Stack>
                </Box>

                <Paper
                    elevation={3}
                    sx={(theme) => ({
                        borderRadius: 3,
                        p: 2.5,
                        border: `1px solid ${theme.palette.divider}`,
                        background: 'linear-gradient(135deg, #ffffff 0%, #f9faff 100%)',
                    })}
                >
                    {items.length === 0 ? (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: 13 }}
                        >
                            No items found for this indent.
                        </Typography>
                    ) : (
                        <>
                            <Typography
                                variant="subtitle2"
                                sx={{ mb: 1.5, fontWeight: 600, fontSize: 14 }}
                            >
                                Items & Received Quantities
                            </Typography>

                            <Stack
                                spacing={0.9}
                                divider={
                                    <Divider
                                        flexItem
                                        sx={{
                                            borderStyle: 'dashed',
                                            opacity: 0.35,
                                        }}
                                    />
                                }
                            >
                                {items.map((it) => {
                                    const rm = it.rawMaterial || {};
                                    const rmName = rm.name || '-';
                                    const unit = rm.unit || '';
                                    const qty = it.requestedQuantity ?? '-';
                                    const itemStatus = (it.status || 'PENDING').toUpperCase();
                                    const isRejected = itemStatus === 'REJECTED';
                                    const alreadyReceived = Number(it.recievedQuantity || 0) > 0;

                                    return (
                                        <Box
                                            key={it._id}
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                py: 0.7,
                                                px: 0.8,
                                                borderRadius: 1.3,
                                                backgroundColor: isRejected ? 'rgba(211, 47, 47, 0.03)' : 'rgba(15, 23, 42, 0.015)',
                                                opacity: isRejected ? 0.7 : 1,
                                                fontSize: 14,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    flex: 1.2,
                                                    pr: 1.2,
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontSize: 16,
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {rmName}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{ fontSize: 14, mt: 0.2 }}
                                                >
                                                    <span style={{ fontWeight: '800' }}>Requested:</span> {qty} {unit}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{ mt: 0.1, fontSize: 14 }}
                                                >
                                                    <span style={{ fontWeight: '800' }}>Est. delivery:</span>{' '}
                                                    {it.expectedDeliveryDate ? formatDate(it.expectedDeliveryDate) : 'Not yet provided'}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    flex: 1,
                                                    minWidth: 230,
                                                    textAlign: 'right',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-end',
                                                    gap: 0.4,
                                                }}
                                            >
                                                {/* <Chip
                                                    size="small"
                                                    label={itemStatus}
                                                    color={statusColor(itemStatus)}
                                                    sx={{
                                                        fontSize: 11.5,
                                                        height: 22,
                                                        textTransform: 'uppercase',
                                                        fontWeight: 600,
                                                    }}
                                                /> */}

                                                <Box
                                                    sx={{
                                                        mt: 0.3,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.8,
                                                    }}
                                                >
                                                    <TextField
                                                        size="small"
                                                        variant="outlined"
                                                        type="number"
                                                        placeholder="Received qty"
                                                        value={receivedMap[it._id] ?? ''}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleReceivedChange(it._id, e.target.value)}
                                                        sx={{
                                                            width: 120,
                                                            '& .MuiInputBase-root.Mui-disabled': {
                                                                backgroundColor: '#bbb0b0ff',
                                                                color: '#000',
                                                                fontWeight: '800'
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: 12,
                                                                py: 0.7,
                                                                textAlign: 'right',
                                                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                                                    WebkitAppearance: 'none',
                                                                    margin: 0,
                                                                },
                                                                MozAppearance: 'textfield',
                                                            },
                                                        }}
                                                        inputProps={{
                                                            min: 0,
                                                        }}
                                                        disabled={isRejected || alreadyReceived}
                                                    />
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                        sx={{ fontSize: 12.5 }}
                                                    >
                                                        {unit}
                                                    </Typography>
                                                </Box>

                                                {isRejected && (
                                                    <Typography
                                                        variant="body2"
                                                        color="error.main"
                                                        sx={{ mt: 0.3, fontSize: 12.5 }}
                                                    >
                                                        Item rejected by admin
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Stack>
                            <Box
                                sx={{
                                    mt: 2,
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    gap: 1,
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleBack}
                                    sx={{ textTransform: 'none', fontSize: 13 }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="contained"
                                    size="small"
                                    onClick={handleSaveReceived}
                                    sx={{ textTransform: 'none', fontSize: 13 }}
                                >
                                    Save Received
                                </Button>
                            </Box>
                        </>
                    )}
                </Paper>
            </Box>
        </Box>
    );
};

export default StockRequestDetails;
